<template>
	<div class="rc-container" :class="{actived:actived,warning:item.not_review_num && item.not_review_num !== '0'}">
		<div class="header flex">
			<div class="new" v-if="item.is_new == 1 && isEnd(item.end_date)">
				NEW
			</div>
			<div class="title">【{{item.title}}】{{authority === 'expert' ? '评审入口' : '校赛入口'}}
				<!-- <el-tooltip class="item" effect="dark" content="点击查看注意事项" placement="top">
					<span class="" @click.stop>{{authority === 'expert' ? '评审注意事项' : '申报注意事项'}}</span>
				</el-tooltip> -->
			</div>
			<div v-if="authority === 'expert'">
				<div class="end-review" :class="[['not','ing','about',''][item.review_status -1]]">
					{{['评审未开始','评审进行中','评审将结束','评审已结束'][item.review_status -1]}}
				</div>
			</div>
			<div v-else>
				<div class="end-review" v-if="!isEnd(item.end_date)">已结束</div>
			</div>
		</div>
		<div class="cell col-center">
			<div>{{authority === 'expert' ? '评审开始时间：' : '开始时间：'}}</div>
			<div>{{item.start_date}}</div>
		</div>
		<div class="cell col-center" v-if="authority === 'expert'">
			<div>{{item.review_status == 3 ? '评审结束剩余：' : '评审结束时间：'}}</div>
			<el-statistic v-if="item.review_status == 3" :value-style="{color:'red',padding:'0',fontSize:'1rem',fontWeight:'bold'}" ref="statistic" format="HH时mm分ss秒" :value="new Date(item.audit_end_date)" time-indices>
			</el-statistic>
			<div v-else>{{item.audit_end_date}}</div>
		</div>
		<div class="cell col-center" v-else>
			<div>结束时间：</div>
			<div>{{item.end_date}}</div>
		</div>
		<div class="cell col-center" v-if="authority === 'expert'">
			<div>已分配项目数：</div>
			<div
				style="margin-right: 1.25rem;padding-top: 0.3125rem;font-weight: bold;color: #409EFF;font-size: 1.125rem;">
				{{item.submit_num || 0}}
			</div>
			<div>已评审数：</div>
			<div
				style="margin-right: 1.25rem;padding-top: 0.3125rem;font-weight: bold;color: #67C23A;font-size: 1.125rem;">
				{{item.review_num || 0}}
			</div>
			<div>未评审数：</div>
			<div style="padding-top: 0.3125rem;font-weight: bold;color: #E6A23C;font-size: 1.125rem;">
				{{item.not_review_num || 0}}
			</div>
		</div>
		<!-- <div class="cell col-center" v-if="authority === 'expert'">
			<div>已评审数：</div>
			<div>{{item.submit_num || 0}}</div>
		</div>
		<div class="cell col-center" v-if="authority === 'expert'">
			<div>未评审数：</div>
			<div>{{item.submit_num || 0}}</div>
		</div> -->
		<div v-else class="cell col-center">
			<div>提交状态：</div>
			<div :class="[['primary','success'][item.status]]">{{['未提交','已提交'][item.status]}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		props: {
			item: {
				type: Object,
				default () {
					return {}
				}
			},
			actived: {
				type: Boolean,
				default: false
			}
		},
		components: {

		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {

		},
		methods: {
			isEnd(date) {
				let end = new Date(date).getTime(),
					time = new Date().getTime()
				if (time > end) {
					return false
				} else {
					return true
				}
			},
		}

	}
</script>

<style lang="scss" scoped>
	.rc-container {
		padding: 0.625rem 1rem;
		border-radius: 0.25rem;
		background-color: #F7FAFE;
		border: 1px solid #DCE1E7;

		.new {
			color: white;
			background-color: #F34A4A;
			font-size: 0.875rem;
			padding: 0 0.25rem;
			margin-right: .5rem;
		}

		.title {
			font-size: 1.125rem;
			font-weight: bold;

			span {
				font-size: 1rem;
				font-weight: 530;
				color: #db0000;
				text-decoration: underline;
				cursor: pointer;
			}
		}

		.cell {
			color: #464646;
			margin-top: 0.625rem;

			.primary {
				color: #4389E0;
			}

			.success {
				color: #00CF13;
			}
			::v-deep{
				.el-statistic{
					width: auto;
					text-align: left;
				}
			}
		}

		.header {
			position: relative;
			align-items: flex-start;

			.new {
				margin-top: 4px;
			}
		}
	}

	.rc-container.actived {
		border: 1px solid #82B3F0;
		background-color: white;
		// box-shadow: 0.25rem 0.25rem 0.625rem rgba(0,0,0,.2);
	}

	.rc-container.warning {

		// border: 1px solid red;
		// background-color: white;
		// box-shadow: 0.25rem 0.25rem 0.625rem rgba(0,0,0,.2);
		.header {

			.title {}
		}

	}

	.end-review {
		position: absolute;
		z-index: 2;
		border-radius: 0.25rem;
		transform: rotate(45deg);
		padding: 0.375rem 0.625rem;
		right: -30px;
		top: 8px;
		border: 1px solid red;
		color: red;
	}

	.end-review.not {
		border: 1px solid rgba(192, 192, 192, .7);
		color: silver;
	}

	.end-review.ing {
		border: 1px solid #67C23A;
		color: #67C23A;
	}

	.end-review.about {
		border: 1px solid #E6A23C;
		color: #E6A23C;
	}
</style>